var React = require('react');

function SparkleHollow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 7a8.516 8.516 0 0 0 7-7 8.516 8.516 0 0 0 7 7 8.516 8.516 0 0 0-7 7 8.516 8.516 0 0 0-7-7z","fill":"currentColor","fillRule":"nonzero"}));
}

SparkleHollow.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = SparkleHollow;

SparkleHollow.default = SparkleHollow;
